import { Component, OnInit, ViewChild } from "@angular/core";
import { MessageService } from "./message.service";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import Swal from "sweetalert2";

@Component({
  selector: "app-messages",
  templateUrl: "./messages.component.html",
  styleUrls: ["./messages.component.css"],
})
export class MessagesComponent implements OnInit {
  @ViewChild("messageSwal", { static: false })
  private messageSwal: SwalComponent;

  constructor(public messageService: MessageService) {
    this.messageService.messagesToShow.subscribe((message) => {
      this.notify(message);
    });
  }

  ngOnInit() {}

  notify(message) {
     if (message && message.text && this.messageSwal) {
      Swal.fire(message);
    }
  }
}
